// extracted by mini-css-extract-plugin
module.exports = {"container":"System_container__2CqWq","blocksContainer":"System_blocksContainer__1T2r1"};